'use strict';
var hasClass = require('./hasClass');

module.exports = function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element)) element.className = element.className + ' ' + className;
};


//////////////////
// WEBPACK FOOTER
// /~/dom-helpers/class/addClass.js
// module id = 1206
// module chunks = 0